import { assets } from '../assets';
import { PersistentVideo } from '../components/PersistentVideo';
import { copy } from '../copy';

/**
 * Kiosk step 1. Looping character footage behind a standing instruction. Touch
 * anywhere to start — the whole screen is the button, because a guest walking
 * past a signage board will not hunt for a target.
 *
 * This is also the reset destination for every idle timeout, so it must be
 * cheap to mount and hold nothing from the previous session.
 */
export function AttractScreen({ onStart }: { onStart: () => void }) {
  return (
    <div
      onPointerDown={onStart}
      data-testid="attract"
      className="relative h-full min-h-[var(--app-h)] w-full overflow-hidden bg-ink"
      role="button"
      tabIndex={0}
      aria-label={copy.attract.cta}
    >
      {/*
        One element for the life of the page, parked between guests rather than
        re-fetched: the loop is 20MB and every reset used to load it again,
        which is where the occasional placeholder box came from. See
        PersistentVideo.
      */}
      <PersistentVideo
        id="attract"
        src={assets.attractLoop}
        label="Attract loop"
        loop
        muted
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/*
        The touch line and nothing else, per the storyboard board. The attract
        footage carries the idea; a heading here competed with it, and the one
        that used to sit here had the character logic backwards.

        Set in bone rather than straw: straw is now a dry-grass midtone from the
        key art, which disappears against the pale footage this sits over.
      */}
      <div className="absolute inset-0 flex flex-col items-center justify-end bg-gradient-to-t from-ink via-ink/60 to-transparent px-16 pb-32 text-center">
        <p className="animate-pulse text-5xl uppercase tracking-[0.3em] text-bone">
          {copy.attract.cta}
        </p>
      </div>
    </div>
  );
}
